import { Auth } from 'aws-amplify';

import UserBase from '@/views/User/Layout';
import Dashboard from '@/views/User/Dashboard';
import Members from '@/views/User/Member/List';
import Events from '@/views/User/Event/List';
import Files from '@/views/User/File/List';
import Commercials from '@/views/User/Commercial/List';
import Branches from '@/views/User/Branch/List';
import Settings from '@/views/User/Settings';

function loggedIn(to, from, next) {
  Auth.currentAuthenticatedUser().then(() => {
    next();
  }).catch(() => {
    next({ name: 'GuestBase' });
  });
}

export default [
  {
    path: '/ua',
    name: 'UserBase',
    component: UserBase,
    beforeEnter: loggedIn,
    redirect: { name: 'Dashboard' },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings,
      },
      {
        path: 'member',
        name: 'Members',
        component: Members,
      },
      {
        path: 'event',
        name: 'Events',
        component: Events,
      },
      {
        path: 'file',
        name: 'Files',
        component: Files,
      },
      {
        path: 'commercial',
        name: 'Commercials',
        component: Commercials,
      },
      {
        path: 'branch',
        name: 'Branches',
        component: Branches,
      },
    ],
  },
];
